import { userRulesReducer } from '@appService/stores/user-rules/user-rules.reducer'
import { paramsConfigReducer } from '@appService/stores/params-config/params-config.reducer'


export const StoresModel = {
  userRules: userRulesReducer,
  paramConfig: paramsConfigReducer
}
